import classNames from 'classnames';
import React from 'react';
import { CloseIcon } from './assets';
import styles from './style.module.scss';
import type { IProps } from './types';

export const Chip = ({
  children,
  closable = true,
  disabled,
  prevIcon,
  closeIcon,
  size = 'middle',
  background = '#FBFBFB',
  color = '#444F66',
  borderColor = '#BCCCE0',
  onClose: onCloseProp,
  style,
  className,
}: IProps): React.JSX.Element => {
  /**
   * Closes the chip by forwarding the event to the caller. Invokes the optional onClose prop with the original event and does nothing when no handler was supplied.
   *
   * @param e - The close event raised by the chip.
   * @returns Nothing.
   */
  const onClose = (e: any) => {
    onCloseProp?.(e);
  };

  return (
    <div
      className={classNames(
        styles.chip,
        size === 'small' ? styles['chip-small'] : '',
        size === 'large' ? styles['chip-large'] : '',
        disabled ? styles['chip-disabled'] : '',
        className,
      )}
      style={{
        background,
        color,
        borderColor,
        ...style,
      }}
    >
      {prevIcon && <div className={styles.chipIcon}>{prevIcon}</div>}
      {children}

      {closable && (
        <div className={styles.chipClose} onClick={onClose} aria-hidden>
          {closeIcon || <img src={CloseIcon} height={12} width={12} alt="closeIcon" />}
        </div>
      )}
    </div>
  );
};

export default Chip;
